/** Persists across logout so login page can show "Welcome Back". */
export const ADMIN_LOGIN_RETURNING_KEY = 'sas_admin_login_returning';
